import * as Api from '@/helpers/restApi'

export default {
  state: {
    ShowRegionsEditorView: false,
    RegionsData: null,
    RegionInfoData: null,
    SucssesMessage: false
  },
  getters: {
    getShowRegionsEditorView: state => state.ShowRegionsEditorView,
    getRegionsData: state => state.RegionsData,
    getRegionInfoData: state => state.RegionInfoData,
    getSucssesMessage: state => state.SucssesMessage
  },
  mutations: {
    SetM_RegionsData (state, val) {
      state.RegionsData = val
    },
    SetM_RegionInfoData (state, val) {
      state.RegionInfoData = val
    },
    SetM_ShowRegionsEditorView (state, val) {
      state.ShowRegionsEditorView = val
    },
    SetM_SucssesMessage (state, val) {
      state.SucssesMessage = val
    }
  },
  actions: {
    SetA_RegionsData ({ state, dispatch, commit }) {
      Api.getApi({
        url: '/api/Regions'
      })
        .then((data) => {
          if (data.Succeeded) {
            commit('SetM_RegionsData', data.Data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    SetA_RegionInfoData ({ state, dispatch, commit }, val) {
      Api.putApi({
        url: '/api/RegionInfos/GetRegionInfo',
        payload: val
      })
        .then((data) => {
          if (data.Succeeded) {
            commit('SetM_RegionInfoData', data.Data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    SetA_RegionInfoSave ({ state, dispatch, commit }, val) {
      Api.putApi({
        url: '/api/RegionInfos/PutForm',
        payload: val
      })
        .then((data) => {
          if (data.Succeeded) {
            commit('SetM_SucssesMessage', true)
            dispatch('SetA_RegionInfoData', {
              RegionId: val.RegionId,
              UniversalTagId: val.UniversalTagId,
              Year: val.Year
            })
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    }
  }
}
